const urls = [
  {
    title: 'Navigation',
    items: [
      {
        url: '',
        icon: 'link',
        title: 'Quick Links',
        permissions: {},
        badge: {
          className: 'badge badge-danger badge-sm badge-outline',
          title: ''
        },
        items: [
          {
            url: '/pages/work-order',
            icon: 'work',
            title: 'Work Order',
            items: [],
            permissions: { 'permAreaKey': 'workOrder', 'permTypeKey': 'create' },
          },
          {
            url: '/pages/quote',
            icon: 'format_quote',
            title: 'Quote',
            permissions: { 'permAreaKey': 'quote', 'permTypeKey': 'create' },
            items: []
          },
          {
            url: '/pages/customer',
            icon: 'people',
            title: 'Customer',
            permissions: { 'permAreaKey': 'customer', 'permTypeKey': 'create' },
            items: []
          },
          {
            url: '/pages/quote-approved',
            icon: 'accessibility',
            title: 'Quote Approve',
            permissions: { 'permAreaKey': 'quote', 'permTypeKey': 'view' },
            items: []
          },
          {
            url: '/pages/user',
            icon: 'accessibility',
            title: 'User',
            permissions: { 'permAreaKey': 'user', 'permTypeKey': 'view' },
            items: []
          }
        ]
      },
      {
        url: '/pages/dashboards',
        icon: 'dashboard',
        title: 'Dashboards',
        permissions: { 'permAreaKey': 'workOrder', 'permTypeKey': 'view' },
        items: []
      },
      {
        url: '/pages/work-orders',
        icon: 'style',
        title: 'Work Orders',
        permissions: { 'permAreaKey': 'workOrder', 'permTypeKey': 'view' },
        items: [],
      },
      {
        url: '/pages/login',
        icon: 'perm_identity',
        title: 'Login',
        permissions: { 'permAreaKey': 'forUnAuth' },
        items: []
      },
      {
        url: '/pages/calendar',
        icon: 'perm_contact_calendar',
        title: 'Calendar',
        permissions: { 'permAreaKey': 'workOrder', 'permTypeKey': 'view' },
        items: []
      },
      {
        url: '/pages/people',
        icon: 'accessibility',
        title: 'People',
        permissions: { 'permAreaKey': 'user', 'permTypeKey': 'view' },
        items: []
      },
      {
        url: '/pages/materials',
        icon: 'shopping_cart',
        title: 'Materials',
        permissions: { 'permAreaKey': 'materials_inventory', 'permTypeKey': 'view' },
        items: []
      },
      {
        url: '/pages/roles',
        icon: 'people',
        title: 'Roles',
        permissions: { 'permAreaKey': 'roles', 'permTypeKey': 'view' },
        items: []
      },
      {
        url: '/pages/employees',
        icon: 'accessibility',
        title: 'Employees',
        permissions: { 'permAreaKey': 'employee', 'permTypeKey': 'view' },
        items: []
      },
      {
        url: '/pages/shops',
        icon: 'shop',
        title: 'Shops',
        permissions: { 'permAreaKey': 'shops', 'permTypeKey': 'view' },
        items: []
      },
      {
        url: '/pages/jobcardstemplate',
        icon: 'card_travel',
        title: 'Job Cards Template',
        permissions: { 'permAreaKey': 'jobCardTemplateFields', 'permTypeKey': 'view' },
        items: []
      },
      {
        url: '/pages/emailtemplates',
        icon: 'email',
        title: 'Email Template',
        permissions: { 'permAreaKey': 'emailTemplate', 'permTypeKey': 'view' },
        items: []
      },
      {
        url: '/pages/boardsettings',
        icon: 'settings',
        title: 'Board Settings',
        permissions: { 'permAreaKey': 'boardSettings', 'permTypeKey': 'view' },
        items: []
      },
      {
        url: '/pages/analytics',
        icon: 'track_changes',
        title: 'Analytics',
        permissions: { 'permAreaKey': 'analytic', 'permTypeKey': 'view' },
        items: []
      },
      {
        url: '/pages/quotes',
        icon: 'format_quote',
        title: 'Quotes',
        permissions: { 'permAreaKey': 'quote', 'permTypeKey': 'view' },
        items: []
      },
      {
        url: '/pages/customers',
        icon: 'account_circle',
        title: 'Customers',
        permissions: { 'permAreaKey': 'customer', 'permTypeKey': 'view' },
        items: []
      },
      {
        url: '/pages/vendors',
        icon: 'person_pin',
        title: 'Vendors',
        permissions: { 'permAreaKey': 'vendor', 'permTypeKey': 'view' },
        items: []
      },
      {
        url: '/pages/archive',
        icon: 'archive',
        title: 'Archive',
        permissions: [{ 'permAreaKey': 'workOrder', 'permTypeKey': 'view' },
        { 'permAreaKey': 'workOrder', 'permTypeKey': 'view' }],
        items: []
      },
      {
        url: '/pages/reports',
        icon: 'account_balance_wallet',
        title: 'Reports',
        permissions: { 'permAreaKey': 'report', 'permTypeKey': 'view' },
        items: [
          {
            url: '/pages/timesheet',
            icon: 'reports',
            title: 'Timesheet',
            items: [],
            permissions: [{ 'permAreaKey': 'time_tracking', 'permTypeKey': 'view' }, { 'permAreaKey': 'time_tracking', 'permTypeKey': 'edit' }],
          },
          {
            url: '/pages/timesheet-summary',
            icon: 'reports',
            title: 'Timesheet Summary',
            items: [],
            permissions: [{ 'permAreaKey': 'time_tracking', 'permTypeKey': 'view' }, { 'permAreaKey': 'time_tracking', 'permTypeKey': 'edit' }],
          },
          {
            url: '/pages/production-cost',
            icon: 'reports',
            title: 'Production Cost',
            items: [],
            permissions: [{ 'permAreaKey': 'time_tracking', 'permTypeKey': 'view' }, { 'permAreaKey': 'time_tracking', 'permTypeKey': 'edit' }],
          },
          {
            url: '/pages/worktime',
            icon: 'reports',
            title: 'Work Time',
            items: [],
            permissions: [{ 'permAreaKey': 'time_tracking', 'permTypeKey': 'view' }, { 'permAreaKey': 'time_tracking', 'permTypeKey': 'edit' }],
          },
          {
            url: '/pages/reports',
            icon: 'report',
            title: 'Production Log Reports',
            items: [],
            permissions: { 'permAreaKey': 'workOrder', 'permTypeKey': 'create' },
          },
          {
            url: '/pages/materials-report',
            icon: 'report',
            title: 'Materials Log Reports',
            items: [],
            permissions: { 'permAreaKey': 'workOrder', 'permTypeKey': 'create' },
          },
        ]
      },
      {
        url: '/pages/check-in',
        icon: 'arrow_forward',
        title: 'Check In',
        permissions: [{ 'permAreaKey': 'time_tracking', 'permTypeKey': 'view' }, { 'permAreaKey': 'time_tracking', 'permTypeKey': 'edit' }],
        items: []
      },
    ]
  },
];

export function navigation(state = Array.from(urls), action) {
  switch (action.type) {
    case 'SET_NAVIGATION':
      return Object.assign({}, state, {
        ...action.navigation
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/navigation.js